import { Card, Typography } from "antd";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import type { SpeciesDistribution } from "../../types/adjacent-crop";

const { Title } = Typography;

interface Props {
  data: SpeciesDistribution[];
  loading?: boolean;
}

export const SurfaceBySpeciesChart = ({ data, loading }: Props) => {
  const chartData = data.map((item) => ({
    species: item.species,
    surface: item.total_surface,
  }));

  return (
    <Card loading={loading}>
      <Title level={5}>Superficie Total por Especie (ha)</Title>
      <ResponsiveContainer width="100%" height={400}>
        <BarChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="species" />
          <YAxis />
          <Tooltip formatter={(value: number) => `${value.toFixed(2)} ha`} />
          <Bar dataKey="surface" fill="#52c41a" name="Superficie (ha)" />
        </BarChart>
      </ResponsiveContainer>
    </Card>
  );
};
